import OpenGraphView from "@/components/command-menu/views/opengraph-view"
import QrCodeView from "@/components/command-menu/views/qrcode-view"
import SettingsView from "@/components/command-menu/views/settings-view"
import { authClient } from "@/lib/auth-client"
import type { MenuItem } from "@/types/const.types"
import {
	Command,
	Github,
	Globe,
	Inbox,
	LogOut,
	MessageCirclePlus,
	QrCode,
	Settings,
	ToggleLeft,
} from "lucide-react"

// Create a function that returns the menu items with the required handlers
export const createSuggestions = (handlers: {
	setIsCommentMode: (value: boolean) => void
	setCommandOpen: (value: boolean) => void
	setCommentsOpen: (value: boolean) => void
}): MenuItem[] => [
	{
		icon: ToggleLeft,
		name: "Feature Flags",
		type: "Application",
		canPin: true,
		color: "#10B981",
		onClick: <SettingsView />,
	},
	{
		icon: MessageCirclePlus,
		name: "Comment",
		type: "Application",
		color: "#3B82F6",
		shortcut: "C",
		canPin: true,
		onClick: () => {
			console.log("Comment mode activated")
			handlers.setIsCommentMode(true)
			handlers.setCommandOpen(false)
		},
	},
	{
		icon: Inbox,
		name: "Inbox",
		type: "Application",
		color: "#8B5CF6",
		canPin: true,
		shortcut: "I",
		onClick: () => {
			handlers.setCommentsOpen(true)
			handlers.setCommandOpen(false)
		},
	},
	{
		icon: Globe,
		name: "Open Graph",
		type: "Application",
		color: "#F59E0B",
		onClick: <OpenGraphView />,
	},
]

export const createCommands = (
	handlers: {
		setIsCommentMode: (value: boolean) => void
		setCommandOpen: (value: boolean) => void
		setCommentsOpen: (value: boolean) => void
	},
	isLoggedIn: boolean,
): MenuItem[] => {
	const commands: MenuItem[] = [
		{
			icon: Github,
			name: "Add Github Integration",
			type: "Command",
			color: "#0052CC",
			canPin: false,
		},
		{
			icon: Command,
			name: "Show Shortcuts",
			type: "Command",
			color: "#10B981",
			canPin: false,
		},
		{
			icon: QrCode,
			name: "Open on mobile",
			type: "Command",
			color: "#3B82F6",
			canPin: false,
			onClick: <QrCodeView />,
		},
		{
			icon: Settings,
			name: "Preferences",
			type: "Command",
			color: "#8B5CF6",
			canPin: true,
			shortcut: "P",
			onClick: <SettingsView />,
		},
	]

	if (isLoggedIn) {
		commands.push({
			icon: LogOut,
			name: "Logout",
			type: "Command",
			color: "#EF4444",
			canPin: false,
			onClick: async () => {
				await authClient.signOut()
				handlers.setCommandOpen(false)
			},
		})
	}

	return commands
}
